/**
 * Tri et filtrage de la liste des configurations de cockpits.
 * Fonctions pures, isolées ici pour être couvertes par `bun test` — le repo n'a
 * pas de harnais de test de composants.
 */

/**
 * Comparateur type-agnostique rendant à chaque type son ordre naturel : les
 * colonnes mélangent nombres (`id`) et chaînes, or `localeCompare` lève sur un
 * nombre et `<` place « Étoile » après « Zebra ».
 * @returns {number} négatif, zéro ou positif
 */
export const compareValues = (x, y) =>
  typeof x === 'number' && typeof y === 'number'
    ? x - y
    : String(x ?? '').localeCompare(String(y ?? ''));

// Minuscule + accents retirés : les cockpits portent des noms français, taper
// « etoile » doit trouver « Étoile ».
const fold = (value) =>
  String(value ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '');

/**
 * Un cockpit correspond-il à la recherche ? Une requête vide accepte tout.
 * @param {object} cockpit
 * @param {string} query
 * @returns {boolean}
 */
export const matchesQuery = (cockpit, query) => {
  const needle = fold(query.trim());
  if (!needle) return true;

  // `join` rend déjà `null`/`undefined` en chaîne vide : un champ absent ne peut
  // pas injecter le mot « undefined » dans la recherche.
  const haystack = fold([cockpit.id, cockpit.name, cockpit.slug, cockpit.description].join(' '));
  return haystack.includes(needle);
};
